import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {getDiamondImage, formatDiamondTitle, formatMeasurements, formatLocation, formatCut, formatCarat, formatCost, formatColor, formatPrice, formatClarity} from '../../../utils/formatting';

import * as headerActionCreators from '../../../actions/header';
import * as leadsActionCreators from '../../../actions/leads';
import * as messagesActionCreators from '../../../actions/messages';
import * as usersActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, headerActionCreators, leadsActionCreators, messagesActionCreators, usersActionCreators);

class SendLeadDropdown extends React.Component {

	constructor(props) {
		super(props);

    this.state = {
      recipients: [],
      
      recipientInput: '',
      messageBody: '',

      errorRecipient: null,
      errorMessage: null,      

      displayInput: true,
      displayAutocomplete: false,
      autocompleteUsers: [],

      serverError: null,
      sendingRequest: false,
    }

    // Fetch user messages
    if(this.props.messages.userMessages === null) {
      this.props.fetchUserMessages()
      .then((respData) => {
        this.props.messagesSave(respData.messages);
      })
      .catch((errorResp) => {
        // Do nothing; expected error if not logged in
        // console.error(errorResp);
      });      
    }

    // Fetch user directory
    if(this.props.messages.directory === null) {
      this.props.fetchUserDirectory()
      .then((respData) => {
        this.props.messagesSaveDirectory(respData.users);
      })
      .catch((errorResp) => {
        // Do nothing; expected error if not logged in
        // console.error(errorResp);
      });      
    }
	}

  closeDropdown() {
    this.props.headerCloseSendLeadDropdown();
  }

  getRootClass() {
    return this.props.header.sendLeadDropdownOpen ? 'SendLeadDropdown open' : 'SendLeadDropdown';
  }

  setAutocomplete() {
    let suggestions = [];
    for(let i = 0; i < this.props.messages.directory.length; i++) {

      let inputLower = this.state.recipientInput.toLowerCase();

      let firstLower = this.props.messages.directory[i].first_name.toLowerCase();
      let lastLower = this.props.messages.directory[i].last_name.toLowerCase();
      let nameLower = firstLower + ' ' + lastLower;
      let emailLower = this.props.messages.directory[i].email.toLowerCase();

      if(inputLower === '' || firstLower.includes(inputLower) || lastLower.includes(inputLower) || nameLower.includes(inputLower) || emailLower.includes(inputLower)) {
        suggestions.push(this.props.messages.directory[i]);
      }
    }
    this.setState({ autocompleteUsers: suggestions });
  }

  changeRecipientInput(evt) {
    this.setState({ recipientInput: evt.target.value }, () => {
      this.setAutocomplete();
    });
  }

  changeMessage(evt) {
    this.setState({ messageBody: evt.target.value }, () => {
      if(this.state.errorMessage && this.state.messageBody) {
        this.setState({ errorMessage: null });
      }
    });
  }

  validateRecipientInput(evt) {
    if(this.state.recipients.length === 0) {
      this.setState({
        errorRecipient: 'Please select a user',  
      });
    }
  }

  validateMessage(evt) {
    if(this.state.messageBody.trim() === '') {
      this.setState({
        errorMessage: 'Please enter a message',  
      });
    }
  }

  openAutocomplete() {
    this.setState({ displayAutocomplete: true }, () => {
      this.setAutocomplete();
    });
  }

  closeAutocomplete() {
    this.setState({ displayAutocomplete: false }); 
  }

  selectRecipient(user) {

    let alreadySelected = false;
    for(let i = 0; i < this.state.recipients.length; i++) {
      if(this.state.recipients[i].id === user.id) {
        alreadySelected = true;
      }
    }

    let newRecipients = [];
    for(let i = 0; i < this.state.recipients.length; i++) {
      newRecipients.push(this.state.recipients[i]);
    }

    if(!alreadySelected) {
      newRecipients.push(user);
    }

    this.setState({
      recipients: newRecipients,
      displayInput: false,
      recipientInput: '',
      displayAutocomplete: false,
      errorRecipient: null,
    });
  }

  showInput() {
    this.setState({ displayInput: true });
  }

  removeRecipient(recipient) {
    
    let newRecipients = [];
    for(let i = 0; i < this.state.recipients.length; i++) {
      if(this.state.recipients[i].id !== recipient.id) {
        newRecipients.push(this.state.recipients[i]);
      }
    }

    this.setState({
      recipients: newRecipients,
    }, () => {
      if(this.state.recipients.length === 0) {
        this.showInput();
      }
    });
  }

  validateAll() {
    let hasErrors = true;
    
    // Required params
    let errorRecipient = null;

    if(this.props.messages.selectedRecipient === null) {
      errorRecipient = this.state.recipients.length === 0 ? 'Please select a recipient' : null;  
    }
    let errorMessage = this.state.messageBody === '' ? 'Please enter a message' : null;

    if(errorRecipient === null &&
       errorMessage === null) {
      hasErrors = false;
    }

    this.setState({
      errorRecipient: errorRecipient,
      errorMessage: errorMessage,
    });

    return !hasErrors;
  }

  handleSubmit() {
    if(this.validateAll()) {

      let recipient_ids = [];
      if(this.props.messages.selectedRecipient) {
        recipient_ids = [ this.props.messages.selectedRecipient.id ];
      } else {
        for(let i = 0; i < this.state.recipients.length; i++) {
          recipient_ids.push(this.state.recipients[i].id);
        }
      }
      
      let messageData = {
        card_id: this.props.header.sendLeadCard.id,
        recipients: recipient_ids,
        message_body: this.state.messageBody,
      }

      this.setState({
        sendingRequest: true,
        serverError: null,
      });

      this.props.leadsSendCard(messageData)
      .then((respData) => {
                
        this.props.headerCloseSendLeadDropdown();
        this.props.messagesShowConfirmation();

        this.setState({
          sendingRequest: false,
          serverError: null,
          recipients: [],
          recipientInput: '',
          messageBody: '',
          errorRecipient: null,
          errorMessage: null,      
          displayAutocomplete: false,
          displayInput: true,
          autocompleteUsers: [],
        });
      })
      .catch((errorResp) => {
        // console.error(errorResp);
        this.setState({
          sendingRequest: false,
          serverError: errorResp.message,
        });
      });
    }
  }

  getRecipientDisplayName(recipient) {
    return recipient.first_name + ' ' + recipient.last_name;
  }

  getRecipientDisplayEmail(recipient) {
    return recipient.email;
  }

  getDropdownTitle() {
    return 'Share Customer With';
  }

  closeSendLeadDropdown() {
    this.props.headerCloseSendLeadDropdown();
  }

	render() {
		return <div className={this.getRootClass()}>
      <div className='innerWrapper'>
        <div className='closeIcon' onClick={this.closeSendLeadDropdown.bind(this)}>&times;</div>
        <div className='newTitle'>{this.getDropdownTitle()}</div>
        <div className='recipientWrapper'>
          {this.props.messages.selectedRecipient !== null ?
            <div className='selectedRecipientList'>
              <div className='selectedRecipient'>
                <div className='nameWrapper'>{this.getRecipientDisplayName(this.props.messages.selectedRecipient)}</div>
                <div className='emailWrapper'>{this.getRecipientDisplayEmail(this.props.messages.selectedRecipient)}</div>
                {this.props.messages.selectedRecipient === null ?
                  <div className='removeRecipient' onClick={this.removeRecipient.bind(this)}>&times;</div> :
                  null
                }
              </div>
            </div> :
            <div className='selectedRecipientList'>
              {this.state.recipients.map((recipient, i) => {
                return <div className='selectedRecipient' key={i}>
                  <div className='nameWrapper'>{this.getRecipientDisplayName(recipient)}</div>
                  <div className='emailWrapper'>{this.getRecipientDisplayEmail(recipient)}</div>
                  {this.props.messages.selectedRecipient === null ?
                    <div className='removeRecipient' onClick={() => this.removeRecipient(recipient)}>&times;</div> :
                    null
                  }
                </div>
              })}
              {this.state.recipients.length > 0 && !this.state.displayInput?
                <div className='addNewLink' onClick={this.showInput.bind(this)}>Add New Recipient</div> :
                null
              }
            </div>
          }
          {this.state.displayInput ?
            <div>
              <input 
                type='text'
                className={this.state.errorRecipient ? 'messageInput error' : 'messageInput'}
                value={this.state.recipientInput}
                placeholder='First name, last name, email'
                onChange={this.changeRecipientInput.bind(this)}
                onFocus={this.openAutocomplete.bind(this)}
                onBlur={this.closeAutocomplete.bind(this)} />
              <div className={this.state.displayAutocomplete ? 'autocompleteWrapper open' : 'autocompleteWrapper'}>
                {this.state.autocompleteUsers.length === 0 ?
                  <div className={'autocompleteEntry nullAutocomplete'}>No matching users found</div> :
                  <div>
                    {this.state.autocompleteUsers.map((user, i) => {
                      return <div className='autocompleteEntry' onClick={() => this.selectRecipient(user)} key={i}>
                        <div className='nameWrapper'>{user.first_name + ' ' + user.last_name}</div>
                        <div className={'emailWrapper EllipsisElement'}>{user.email}</div>
                      </div>
                    })}
                  </div>
                }
              </div>
            </div> :
            null
          }        
        </div>
        <div className='bodyWrapper'>
          <textarea
            placeholder = 'Message'
            className={this.state.errorMessage ? 'messageTextarea error' : 'messageTextarea'}
            onChange={this.changeMessage.bind(this)} 
            value={this.state.messageBody}
            onBlur={this.validateMessage.bind(this)}></textarea>
        </div>
        <div className='sendMessageWrapper'>
          <div 
            className={'actionButton sendButton'} 
            disabled={!this.state.sendingRequest} 
            onClick={this.handleSubmit.bind(this)}>Send</div>
        </div>
      </div>
    </div>;
	}
}
export default SendLeadDropdown;

function mapStateToProps(state) {
  return {
    messages: state.messages,
    header: state.header,
  };
}

export const SendLeadDropdownContainer = connect(
  mapStateToProps,
  allActionCreators
)(SendLeadDropdown);